const prefix = '@user/'

export default {
  UPDATEBREAD: `${prefix}UPDATEBREAD`
}
